import { render, staticRenderFns } from "./farmApplyList.vue?vue&type=template&id=47a8c824&scoped=true&"
import script from "./farmApplyList.vue?vue&type=script&lang=js&"
export * from "./farmApplyList.vue?vue&type=script&lang=js&"
import style0 from "./farmApplyList.vue?vue&type=style&index=0&id=47a8c824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a8c824",
  null
  
)

export default component.exports